/* BOLTRON (page.boltron) · 02 Real Moments carousel.
   snippets/boltron-moments.liquid. Two modes:
   - Desktop (≥990px), same as the Billiardo story carousel: a native
     horizontal scroll row (scroll-snap, trackpad/drag-friendly). The slide
     nearest the centre is .is-active (in focus); the others stay dimmed in
     CSS. Arrows and numbers scroll to a slide; no loop.
   - Mobile: each slide gets data-pos 0 (centre), -1 / 1 (beside it) or
     'off'; position and scale live in CSS. Loops; swipe of 40px steps.
   Shared: arrows and a counter with a progress fill (04 ━━── 10), ← / → keys. */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  Array.prototype.forEach.call(document.querySelectorAll('[data-bh-moments]'), function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-bh-moments-slide]'));
    var now = carousel.querySelector('[data-bh-moments-now]');
    var fill = carousel.querySelector('[data-bh-moments-fill]');
    var status = carousel.querySelector('[data-bh-moments-status]');
    var track = carousel.querySelector('[data-bh-moments-track]');
    var prev = carousel.querySelector('[data-bh-moments-prev]');
    var next = carousel.querySelector('[data-bh-moments-next]');
    var total = slides.length;
    if (!track || total === 0) return;

    var current = 0;

    var lastShown = -1;
    var syncBars = function () {
      if (current === lastShown) return;
      lastShown = current;
      var n = current + 1;
      if (now) now.textContent = (n < 10 ? '0' : '') + n;
      if (fill) fill.style.width = (n / total * 100) + '%';
      if (status) status.textContent = 'Image ' + n + ' of ' + total;
    };

    /* ── Desktop: native scroll row ─────────────────────────────────── */
    var nearestToCentre = function () {
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - centre);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    };
    var markActive = function () {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === total - 1;
      syncBars();
    };
    var scrollToSlide = function (index, instant) {
      var slide = slides[index];
      track.scrollTo({
        left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2,
        behavior: instant ? 'auto' : 'smooth'
      });
    };

    /* ── Mobile: positioned cards ───────────────────────────────────── */
    var offset = function (index) {
      var diff = index - current;
      if (total > 2) {
        if (diff > total / 2) diff -= total;
        if (diff < -total / 2) diff += total;
      }
      return diff;
    };
    var renderCards = function () {
      slides.forEach(function (slide, index) {
        var pos = offset(index);
        slide.setAttribute('data-pos', Math.abs(pos) <= 1 ? String(pos) : 'off');
        slide.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        if (Math.abs(pos) <= 1) {
          var img = slide.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        }
      });
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
      syncBars();
    };

    var go = function (index) {
      if (desktop.matches) {
        current = Math.max(0, Math.min(total - 1, index));
        markActive();
        scrollToSlide(current);
      } else {
        current = ((index % total) + total) % total;
        renderCards();
      }
    };

    var applyMode = function () {
      if (desktop.matches) {
        slides.forEach(function (slide) { slide.removeAttribute('data-pos'); });
        markActive();
        scrollToSlide(current, true);
      } else {
        slides.forEach(function (slide) { slide.classList.remove('is-active'); });
        renderCards();
      }
    };

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
    });

    /* Desktop: follow the user's own scrolling (trackpad, drag, keys).
       A few offset reads per event: cheap, so no frame throttling. */
    track.addEventListener('scroll', function () {
      if (!desktop.matches) return;
      var best = nearestToCentre();
      if (best !== current) {
        current = best;
        markActive();
      }
    }, { passive: true });

    /* Desktop: a click on a dimmed photo brings it into focus.
       Mobile: tapping a side card brings it to the centre. */
    var moved = false;
    slides.forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        if (moved) return;
        if (desktop.matches) {
          if (index !== current) go(index);
        } else {
          var pos = offset(index);
          if (pos === -1 || pos === 1) go(index);
        }
      });
    });

    /* Mobile swipe: a horizontal drag of 40px or more steps one slide. */
    var startX = null;
    var startY = 0;
    track.addEventListener('pointerdown', function (event) {
      if (desktop.matches) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      moved = false;
    });
    track.addEventListener('pointermove', function (event) {
      if (startX === null) return;
      if (Math.abs(event.clientX - startX) > 8) moved = true;
    });
    track.addEventListener('pointerup', function (event) {
      if (startX === null) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      startX = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      window.setTimeout(function () { moved = false; }, 0);
    });
    track.addEventListener('pointercancel', function () { startX = null; });
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });

    if (desktop.addEventListener) desktop.addEventListener('change', applyMode);
    carousel.classList.add('is-ready');
    applyMode();
  });
})();
